export default "__VITE_PUBLIC_ASSET__273bbdc9__"